export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14154.2312259d.jpg";